// ConfirmPasswordChangeNumber.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Modal } from "../../../components";
import { EndPoints } from "../../../Constants/endpoints";
import { useAppDispatch, usePostData } from "../../../hooks";
import { setChangePhoneNumberId } from "../../../redux/reducers/registrationSlice";
import { useToast } from "../../../Services/ToastContext";
import ConfirmPasswordForm from "./ConfirmPasswordForm";

interface ConfirmPasswordChangeNumberProps {
  isOpen: boolean;
  onClose: () => void;
}

const ConfirmPasswordChangeNumber: React.FC<
  ConfirmPasswordChangeNumberProps
> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { mutate, isPending } = usePostData(EndPoints.ChangePhoneNumberRequest);
  const { showToast } = useToast();

  const handleFormSubmit = (data: { Password: string }) => {
    mutate(
      { Password: data.Password },
      {
        onSuccess: (response: any) => {
          if (response.Data && response.Data.Id) {
            dispatch(setChangePhoneNumberId(response.Data.Id));
            navigate("/change-phone-number/add-new");
          }
        },
        onError: (error: any) => {
          showToast(error.message || error, "error");
        },
      },
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      customStyle="!min-w-80 !w-fit "
      showClose={false}
      onClose={onClose}
      header={t("change_number")}
    >
      <ConfirmPasswordForm
        onSubmitSuccess={handleFormSubmit}
        onCancel={onClose}
        isPending={isPending}
      />
    </Modal>
  );
};

export default ConfirmPasswordChangeNumber;